import React from 'react';
import App, { Container } from 'next/app';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
// import JssProvider from 'react-jss/lib/JssProvider';

import theme from 'utils/theme';

import initReactFastclick from 'react-fastclick';

initReactFastclick();

class MyApp extends App {
  constructor() {
    super();
    // this.pageContext = getPageContext();
  }

  componentDidMount() {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log('CUSTOM ERROR HANDLING', error);
    // This is needed to render errors correctly in development / production
    super.componentDidCatch(error, errorInfo);
  }
  render() {
    const { Component, pageProps } = this.props;
    return (
      <Container>
        {/* <JssProvider
        registry={this.pageContext.sheetsRegistry}
        generateClassName={this.pageContext.generateClassName}
       /> */}
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          {/* Pass pageContext to the _document though the renderPage enhancer
                to render collected styles on server-side. */}
          <Component pageContext={this.pageContext} {...pageProps} />
        </ThemeProvider>
      </Container>
    );
  }
}

export default MyApp;
